/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkcodeinvaliderror4Inputs */

const en_profilelinkcodeinvaliderror4 = /** @type {(inputs: Profilelinkcodeinvaliderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code is wrong or expired. Show a new one in the app.`)
};

const de_profilelinkcodeinvaliderror4 = /** @type {(inputs: Profilelinkcodeinvaliderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Code stimmt nicht oder ist abgelaufen. Lass dir in der App einen neuen zeigen.`)
};

/**
* | output |
* | --- |
* | "The code is wrong or expired. Show a new one in the app." |
*
* @param {Profilelinkcodeinvaliderror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkcodeinvaliderror4 = /** @type {((inputs?: Profilelinkcodeinvaliderror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkcodeinvaliderror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkcodeinvaliderror4(inputs)
	return de_profilelinkcodeinvaliderror4(inputs)
});
export { profilelinkcodeinvaliderror4 as "profileLinkCodeInvalidError" }